"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _reactRedux = require("react-redux");
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash.bindall"));
var _parseColor = _interopRequireDefault(require("parse-color"));
var _strokeStyle = require("../reducers/stroke-style");
var _strokeWidth = require("../reducers/stroke-width");
var _itemNameIndicator = _interopRequireDefault(require("../components/item-name-indicator/item-name-indicator"));
var _selection = require("../helper/selection");
var _stylePath = require("../helper/style-path");
var _gradientTypes = _interopRequireDefault(require("../lib/gradient-types"));
var _modes = _interopRequireDefault(require("../lib/modes"));
var _format = _interopRequireWildcard(require("../lib/format"));
var _reactPopover = _interopRequireDefault(require("react-popover"));
var _group = require("../helper/group");
var _labeledIconButton = _interopRequireDefault(require("../components/labeled-icon-button/labeled-icon-button"));
var _assignDropdown = _interopRequireDefault(require("../components/fixed-tools/icons/assign-dropdown.svg"));
var _multiselectDropdown = _interopRequireDefault(require("../components/forms/multiselect-dropdown"));
var _groupNameSelect = _interopRequireDefault(require("../components/forms/group-name-select"));
var _setAvailable = _interopRequireDefault(require("../components/forms/set-available"));
var _setClickable = _interopRequireDefault(require("../components/forms/set-clickable"));
var _maxCapacity = _interopRequireDefault(require("../components/forms/max-capacity"));
var _classnames = _interopRequireDefault(require("classnames"));
var _inputModule = _interopRequireDefault(require("../components/forms/input.module.css"));
var _alertTopError = require("../reducers/alert-top-error");
var _setElementModal = require("../reducers/set-element-modal");
var _selectedItems = require("../reducers/selected-items");
var _material = require("@mui/material");
var _styledButton = _interopRequireDefault(require("../../../styled/styledButton"));
var _dropdownIcon = _interopRequireDefault(require("../components/fixed-tools/icons/dropdownIcon"));
var ItemNameIndicator = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ItemNameIndicator, _React$Component);
  var _super = (0, _createSuper2.default)(ItemNameIndicator);
  function ItemNameIndicator(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ItemNameIndicator);
    _this = _super.call(this, props);
    _this.state = {
      modalStatus: false,
      appliedName: null,
      attributes: [],
      groupName: null,
      available: null,
      capacityVal: null,
      showCapacity: false,
      isSeat: false,
      duplicateName: false
    };
    (0, _lodash.default)((0, _assertThisInitialized2.default)(_this), ["handleNameChange", "handleAttributeModal", "handleSubmit", "handleAttributeChange", "groupNameChange", "handleAvailableChange", "handleCapacityChange", "isbtnDisabled", "addRemoveClickable", "checkForDuplicateName"]);
    return _this;
  }
  (0, _createClass2.default)(ItemNameIndicator, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.handleNameChange(nextProps.selectedName);
      this.handleAttributeChange(nextProps.attributeValues, true);
      this.groupNameChange(nextProps.groupName);
      this.handleAvailableChange(nextProps.available);
      this.handleCapacityChange(nextProps.capacityMax);
    }
  }, {
    key: "handleNameChange",
    value: function handleNameChange(name) {
      this.setState({
        duplicateName: false
      });
      this.setState({
        appliedName: name
      });
    }
  }, {
    key: "checkForDuplicateName",
    value: function checkForDuplicateName(itemName) {
      if ((0, _stylePath.checkDuplicateName)(itemName, this.props.textEditTarget)) {
        this.setState({
          duplicateName: true
        });
      } else {
        this.setState({
          duplicateName: false
        });
      }
    }
  }, {
    key: "handleAttributeChange",
    value: function handleAttributeChange(value) {
      var checkClickable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var capacityInitial = 0;
      if (this.state && !this.state.showCapacity) {
        capacityInitial = 1;
      }
      if (checkClickable) {
        this.setState({
          attributes: value
        });
        if (value && value.find(function (e) {
          return e.value === "clickable";
        })) {
          this.setState({
            showCapacity: true
          });
          this.setState({
            isSeat: true
          });
          if (capacityInitial === 1) {
            this.handleCapacityChange(1);
          }
        } else {
          this.setState({
            showCapacity: false
          });
          this.setState({
            isSeat: false
          });
        }
      } else {
        var valueCopy = value ? (0, _toConsumableArray2.default)(value) : [];
        if (this.state.isSeat && value && !value.find(function (e) {
          return e.value === "clickable";
        })) {
          valueCopy.push({
            value: "clickable",
            label: "Set as Seat"
          });
        }
        this.setState({
          attributes: valueCopy
        });
      }
    }
  }, {
    key: "addRemoveClickable",
    value: function addRemoveClickable(isSeat) {
      // if isSeat is true, add 'set as seat' to attribute list, else remove
      var attrList = this.state.attributes ? (0, _toConsumableArray2.default)(this.state.attributes) : [];
      if (isSeat) {
        if (attrList && !attrList.find(function (e) {
          return e.value === "clickable";
        })) {
          attrList.push({
            value: "clickable",
            label: "Set as Seat"
          });
        }
      } else {
        if (attrList && attrList.find(function (e) {
          return e.value === "clickable";
        })) {
          attrList = attrList.filter(function (x) {
            return x.value !== "clickable";
          });
        }
      }
      this.handleAttributeChange(attrList, true);
    }
  }, {
    key: "groupNameChange",
    value: function groupNameChange(value) {
      this.setState({
        groupName: value
      });
    }
  }, {
    key: "handleAvailableChange",
    value: function handleAvailableChange(value) {
      this.setState({
        available: value
      });
    }
  }, {
    key: "handleCapacityChange",
    value: function handleCapacityChange(value) {
      this.setState({
        capacityVal: value
      });
    }
  }, {
    key: "handleAttributeModal",
    value: function handleAttributeModal() {
      if (this.state.modalStatus) {
        (0, _selection.clearSelection)(this.props.clearSelectedItems);
      }
      this.props.modalOpenClose(!this.state.modalStatus);
      this.setState(function (prevState) {
        return {
          modalStatus: !prevState.modalStatus
        };
      });
    }
  }, {
    key: "isbtnDisabled",
    value: function isbtnDisabled() {
      if (this.state && !this.state.appliedName || this.state.appliedName && ((0, _stylePath.containsSpecialChars)(this.state.appliedName) || this.state.appliedName.length > 10)) {
        return true;
      }
      if (this.state && this.state.showCapacity && !this.state.capacityVal || this.state.capacityVal && (this.state.capacityVal < 1 || this.state.capacityVal > 9999999999)) {
        return true;
      }
      return false;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var name = this.state.appliedName ? this.state.appliedName : null;
      var attributes, groupName, available, capacity;
      attributes = [];
      groupName = available = capacity = null;
      if (name) {
        attributes = this.state.attributes ? this.state.attributes : [];
        groupName = this.state.groupName ? this.state.groupName : null;
        if (attributes && attributes.find(function (e) {
          return e.value === "clickable";
        })) {
          capacity = this.state.capacityVal ? this.state.capacityVal : null;
          available = this.state.available ? this.state.available : null;
        } else {
          capacity = null;
          available = null;
        }
      }
      var changed = (0, _stylePath.applyNameAttributesToSelection)(name, attributes, available, capacity, groupName, this.props.textEditTarget);
      if (changed[0]) this.props.onUpdateImage();
      if (changed[1]) {
        //    this.props.showAlert(changed[1])
        this.props.sendAlertMessage(changed[1]);
        this.handleNameChange(this.props.selectedName ? this.props.selectedName : "");
      } else {
        this.handleAttributeModal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_reactPopover.default, {
        body: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", {
          className: _inputModule.default.spaceBottom
        }, this.props.initial ? "Label & Assign item" : "Label & Assign item"), /*#__PURE__*/_react.default.createElement(_itemNameIndicator.default, {
          disabled: this.props.disabled,
          itemName: this.state.appliedName,
          onChangeItemName: this.handleNameChange,
          onFocusOut: this.checkForDuplicateName,
          duplicateName: this.state.duplicateName
        }), /*#__PURE__*/_react.default.createElement(_setClickable.default, {
          initial: this.props.initial,
          itemName: this.state.appliedName,
          clickable: this.state.isSeat,
          addRemoveClickable: this.addRemoveClickable
        }), /*#__PURE__*/_react.default.createElement(_multiselectDropdown.default, {
          multiSelectAttributes: this.props.multiSelectAttributes,
          itemName: this.state.appliedName,
          attributeValues: this.props.attributeValues,
          handleAttributeChange: this.handleAttributeChange
        }), this.state.showCapacity && /*#__PURE__*/_react.default.createElement(_maxCapacity.default, {
          itemName: this.state.appliedName,
          capacity: this.props.capacityMax,
          onCapacityChange: this.handleCapacityChange
        }), this.state.showCapacity && /*#__PURE__*/_react.default.createElement(_setAvailable.default, {
          available: this.props.available,
          itemName: this.state.appliedName,
          onAvailableChange: this.handleAvailableChange
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: _inputModule.default.twoBtnWrp
        }, /*#__PURE__*/_react.default.createElement(_styledButton.default, {
          variant: "outlined",
          disabled: this.isbtnDisabled() || !this.state.appliedName || this.state.duplicateName,
          onClick: this.handleSubmit
        }, this.props.initial ? "Assign" : "Update"), /*#__PURE__*/_react.default.createElement(_styledButton.default, {
          onClick: this.handleAttributeModal,
          variant: "outlined"
        }, "Cancel"))),
        isOpen: this.state.modalStatus,
        place: "below",
        onOuterAction: this.handleAttributeModal,
        className: "itemNamePopover"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _inputModule.default.assignWrp
      }, /*#__PURE__*/_react.default.createElement(_styledButton.default, {
        disabled: !(0, _group.selectedSingleItem)() || !this.props.itemType,
        onClick: this.handleAttributeModal,
        variant: "outlined"
      }, this.props.selectedName ? /*#__PURE__*/_react.default.createElement("span", null, "Edit") : /*#__PURE__*/_react.default.createElement("span", null, "Assign"), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          paddingLeft: "3px"
        }
      }, /*#__PURE__*/_react.default.createElement(_dropdownIcon.default, {
        fillColor: !(0, _group.selectedSingleItem)() || !this.props.itemType ? "#c5c5c5" : "#ff5958"
      }))), this.props.showDetectSeatButton && this.props.create && /*#__PURE__*/_react.default.createElement(_styledButton.default, {
        variant: "outlined",
        onClick: this.props.handleSubmitToAiTool,
        style: {
          marginLeft: "8px"
        }
      }, "Auto detect & Assign")));
    }
  }]);
  return ItemNameIndicator;
}(_react.default.Component);
var mapStateToProps = function mapStateToProps(state) {
  var name;
  var attribute;
  var groupName;
  var availableAttribute;
  var capacity;
  var itemType = true;
  var initial = false;
  if (state.scratchPaint.selectedItems && state.scratchPaint.selectedItems[0]) {
    var parents = [];
    parents.push(state.scratchPaint.selectedItems[0]);
    var parentStack = (0, _selection.findGreaterParent)(state.scratchPaint.selectedItems[0], parents);
    var greaterParent = parentStack[parentStack.length - 2];
    if (greaterParent && greaterParent._data) {
      var greaterParentName = greaterParent._data.id;
      var greaterParentAttributes = greaterParent._data.customAttributes;
      var greaterParentAvailable = greaterParent._data.unavailable;
      var greaterParentCapacity = greaterParent._data.capacity;
      var greaterParentGroupName = greaterParent._data.groupName;
      // const greatetParentItemType = greaterParent.className;

      attribute = greaterParentAttributes;
      name = greaterParentName ? greaterParentName : null;
      initial = greaterParentName ? false : true;
      availableAttribute = greaterParentAvailable ? greaterParentAvailable : null;
      capacity = greaterParentCapacity ? greaterParentCapacity : 1;
      groupName = greaterParentGroupName ? greaterParentGroupName : null;
      //  itemType = (greatetParentItemType === 'Path' || greatetParentItemType === 'Group') ? true : false;
    }

    var greaterParentItemType = greaterParent && greaterParent.className ? greaterParent.className : "";

    // Check if atleast one child/grandchild is a Path or a CompoundPath or a PointText, then set itemType as true
    if (greaterParentItemType && greaterParentItemType === "Group" && greaterParent._children) {
      itemType = (0, _selection.checkIfEditable)(greaterParent._children);
    } // If not a group, then check if it is a Path or a CompoundPath or a PointText
    // If not any any of these, then set itemType as false
    else if (greaterParentItemType && greaterParentItemType !== "Path" && greaterParentItemType !== "CompoundPath"
    //    && greaterParentItemType !== 'PointText' to be recerted
    ) {
      itemType = false;
    }
  }
  return {
    disabled: state.scratchPaint.mode === _modes.default.BRUSH ||
    //    state.scratchPaint.mode === Modes.TEXT ||
    state.scratchPaint.mode === _modes.default.FILL,
    textEditTarget: state.scratchPaint.textEditTarget,
    selectedName: name,
    attributeValues: attribute,
    groupName: groupName,
    selectedItems: state.scratchPaint.selectedItems,
    available: availableAttribute,
    capacityMax: capacity,
    itemType: itemType,
    initial: initial
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showAlert: function showAlert(msg) {
      dispatch((0, _alertTopError.setAlertText)(msg));
    },
    modalOpenClose: function modalOpenClose(status) {
      dispatch((0, _setElementModal.openCloseModal)(status));
    },
    clearSelectedItems: function clearSelectedItems() {
      dispatch((0, _selectedItems.clearSelectedItems)());
    }
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemNameIndicator);
exports.default = _default;